<template>
  <button
    class="baseButton"
    :class="{ disableOpactity: disabled }"
    @click="$emit('click')"
    :style="buttonStyleObj"
    :disabled="disabled"
  >
    {{ text }}
  </button>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    backgroundColor: {
      type: String,
      default: '#9fc5e8',
      required: false,
    },
    textColor: {
      type: String,
      default: '#000000',
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    buttonStyleObj() {
      return {
        'background-color': this.backgroundColor,
        color: this.textColor,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.baseButton {
  margin-bottom: 0;
  box-sizing: border-box;
  font-size: 16px;
  border: 2px solid #9b999d;
}
.disableOpactity {
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/common/button/BaseButton.vue